import {
  ChangeEvent,
  ComponentProps,
  HTMLInputTypeAttribute,
  LegacyRef,
} from "react";
import styled from "styled-components";

interface IsInput extends ComponentProps<"input"> {
  name: string;
  value: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  type?: HTMLInputTypeAttribute;
  placeholder: string;
  autoComplete?: string;
  ref?: LegacyRef<HTMLInputElement>;
  isRed?: boolean;
  disabled?: boolean;
}

export default function InputDefault({
  name,
  value,
  onChange,
  type,
  placeholder,
  autoComplete,
  ref,
  isRed,
  disabled,
}: IsInput) {
  if (type && type === "tel") {
  }

  return (
    <InputDefaultStyle value={value} className="Input" isRed={isRed || false}>
      <input
        name={name}
        value={value}
        onChange={onChange}
        type={type ? type : "text"}
        autoComplete={autoComplete}
        ref={ref}
        disabled={disabled}
      ></input>
      <p className="Placeholder">{placeholder}</p>
    </InputDefaultStyle>
  );
}

const InputDefaultStyle = styled.div<{ value: string; isRed: boolean }>`
  position: relative;
  width: 100%;
  height: 56px;
  background-color: white;
  input {
    position: relative;
    width: 100%;
    height: 50px;
    padding: 12px 16px;
    border-width: 0px 0px 1px 0px;
    border-style: solid;
    border-color: #314af3;
    border-radius: 0px;
    font-family: gmarket-sans-medium;
    font-size: 14px;
    z-index: 10;
    &:focus {
      outline: none;
      border-width: 0px 0px 1px 0px;
    }
  }
  .Placeholder {
    position: absolute;
    display: ${({ value }) => value && "none"};
    top: 0px;
    left: 0px;
    margin-top: 20px;
    margin-left: 18px;
    color: #777777;
    font-size: 14px;
    z-index: 100;
  }
`;
